module.exports = function anonymous(it
/*``*/) {
var out='<div class="overlay__inner1"> <div class="overlay__inner2"> <div class="overlay__inner3"> <button class="overlay__close" data-overlay-close><span class="a11y">Close overlay</span></button> <div class="overlay__content" data-overlay-content></div> <div class="overlay__footer"> <button class="overlay__footer__button overlay__footer__button--prev" data-overlay-prev>Back</button> <button class="overlay__footer__button overlay__footer__button--next" data-overlay-next>Next</button> </div> </div> </div></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./source/scripts/templates/overlay.dot
// module id = 306
// module chunks = 0